exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-block {\n  padding: 0.4em;\n  border-left: 0.4em solid #8c8c8c;\n}\n.uu5-bricks-block.uu5-bricks-block-bg {\n  background-color: #f5f5f5;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/block.less
// module id = 186
// module chunks = 0